import React from 'react'
import { withTranslation } from 'react-i18next'
import FilterPill from '../../shared/FilterPill'
import SearchInput from '../../shared/SearchInput'

export default withTranslation()(function RoleFilterBar({ t, q, onChangeQ, status, onChangeStatus }) {
  const statusOptions = [
    { label: t('settings.role_management.filters.all_statuses'), value: '' },
    { label: t('settings.role_management.filters.active'), value: 'active' },
    { label: t('settings.role_management.filters.inactive'), value: 'inactive' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <SearchInput
        value={q}
        onChange={onChangeQ}
        placeholder={t('settings.role_management.filters.search_placeholder')}
      />

      <FilterPill
        label={t('settings.role_management.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
      />
    </div>
  )
})
